var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('filtro-buscar-itinerarios'),_c('fieldset-component',{staticClass:"mt-4",attrs:{"texto":"Resultados de Búsqueda"}}),_c('buscar-itinerarios-tabla',{attrs:{"data":_vm.dataDatatable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }